import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { useSelector } from 'react-redux';
import {
  getIsGlobalUser,
  getIsLocalUser
} from '../../../../../features/loginSystem/selectors';
// import Button from '../../../../common/Button';
import ButtonGroup from '../../../../common/ButtonGroup';
import {
  ppiCreateRoute,
  ppiCreateFromPublishedPpiRoute
} from '../../../../../routes';

const useStyles = makeStyles(theme => ({
  createButton: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  radioGroupRoot: {
    display: 'block'
  },
  radioButtonRoot: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem'
    }
  },
  ppiLabelContainer: {
    userSelect: 'none'
  }
}));

const GlobalPpiSection = ({
  globalIngredientId,
  onChangeSelectedPpi,
  isExcluded,
  itemCode
}) => {
  const classes = useStyles();
  const isGlobalUser = useSelector(getIsGlobalUser);
  const isLocaUser = useSelector(getIsLocalUser);
  const [selected, setSelected] = useState(isExcluded);

  const localPpiCopy = 'true';

  if (!isGlobalUser) {
    return null;
  }

  const buttonMenuItems = [];

  const dataToPass = isExcluded === undefined ? false : isExcluded;

  function handleExcludeChange(event) {
    setSelected(!selected);
    onChangeSelectedPpi(event, { selected });
  }

  buttonMenuItems.push({
    text: <FormattedMessage id="ppi.copyLocalInstruction" />,
    route: ppiCreateFromPublishedPpiRoute(itemCode, localPpiCopy)
  });

  return (
    <>
      <div className={classes.container}>
        <Typography variant="body2">
          <FormattedMessage id="ppsi.noInstructionsExists" />
        </Typography>
        <ButtonGroup
          route={ppiCreateRoute(globalIngredientId)}
          menuItems={buttonMenuItems}
          classes={{ root: classes.createButton }}
        >
          <FormattedMessage id="ppi.createInstruction" />
        </ButtonGroup>
      </div>
      <div>
        <FormControlLabel
          value={dataToPass}
          control={
            <Radio
              classes={{ root: classes.radioButtonRoot }}
              onClick={event => handleExcludeChange(event)}
              checked={dataToPass}
            />
          }
          label={
            <div className={classes.ppiLabelContainer}>
              <Typography variant="body2">Exclude</Typography>
            </div>
          }
        />
      </div>
    </>
  );
};

GlobalPpiSection.propTypes = {
  globalIngredientId: PropTypes.string.isRequired
};

export default GlobalPpiSection;
